import { Directive, ElementRef, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { getTestClassName } from '../model/features-decl';

type AllowedInputTypes = string | number;

@Directive({
  selector: '[testClass]'
})
export class TestClassDirective implements OnInit, OnDestroy, OnChanges {
  @Input('testClass')
  name: AllowedInputTypes | AllowedInputTypes[];

  /**
   * Разделитель для массива имен
   */
  @Input('testClassSeparator')
  separator: string = '-';

  /**
   * Ставить ли разделитель в конце строки
   */
  @Input('testClassEndSeparator')
  set endWithSeparator(value: boolean | string) {
    this._endWithSeparator = value != null && `${value}` !== 'false';
  }

  private _endWithSeparator: boolean = false;

  constructor(private el: ElementRef<Element>) {}

  ngOnInit(): void {
    if (this.name) {
      this.applyClass(this.name);
    }
  }

  ngOnDestroy(): void {
    if (this.name) {
      this.removeClass(this.name);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['name'] && changes['name'].currentValue) {
      if (changes['name'].previousValue) {
        this.reapplyClass(changes['name'].previousValue, changes['name'].currentValue);
      } else {
        this.applyClass(changes['name'].currentValue);
      }
    }
  }

  private fullClass(name: AllowedInputTypes | AllowedInputTypes[]): string {
    if (Array.isArray(name)) {
      return getTestClassName(name.join(this.separator) + (this._endWithSeparator ? this.separator : ''));
    } else {
      return getTestClassName(`${name}` + (this._endWithSeparator ? this.separator : ''));
    }
  }

  private reapplyClass(oldClass: AllowedInputTypes | AllowedInputTypes[], newClass: AllowedInputTypes | AllowedInputTypes[]) {
    this.removeClass(oldClass);
    this.applyClass(newClass);
  }

  private applyClass(newClass: AllowedInputTypes | AllowedInputTypes[]) {
    this.el.nativeElement.classList.add(this.fullClass(newClass));
  }

  private removeClass(oldClass: AllowedInputTypes | AllowedInputTypes[]) {
    this.el.nativeElement.classList.remove(this.fullClass(oldClass));
  }
}
